import React from 'react'

import ErrorComponent from './ErrorComponent'

interface Props {
  onClose?: () => void
  onError?: (error: Error) => void
  children: React.ReactNode
  error?: React.ComponentType
  translator?: any
}

class ErrorBoundary extends React.Component<Props> {
  public state = {
    hasError: false
  }

  public static getDerivedStateFromError() {
    return { hasError: true }
  }

  public componentDidCatch(error: Error) {
    const { onError } = this.props

    if (onError) {
      onError(error)
    }
  }

  public render() {
    const Error = this.props.error
    const { translator, onClose } = this.props

    if (this.state.hasError) {
      return Error ? <Error /> : (
        <ErrorComponent
          onClose={onClose}
          closeButtonText={translator?.translate('buttons.close') || 'Close'}
        />
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
